import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community'

export default defineNuxtPlugin({
  name: 'ag-grid',
  parallel: true,
  async setup(_nuxtApp) {
    ModuleRegistry.registerModules([AllCommunityModule])
    provideGlobalGridOptions({ theme: 'legacy' })
  },
})
